import * as actionTypes from "../../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  user: null,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  userProfileData:null,
  userPreferencesData: [],
  session: {
    IdToken: null,
    AccessToken: null,
    RefreshToken: null,
    isValid: null,
    email: null,
    name: null,
    first_name: null,
    last_name: null,
    user_role: null,
  },
  loading:false,
  screen_loading: false,
  is_loaded: false,
  forgot_failed: false,
  change_pass_loding: "",
  userDatabase:"",
  privacyData: null,
  userLogout: false,
  isUserverification: false,
  googleProfilePicture: null,
  gravatarImg: null
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.LOGIN_USER_SUCCESS:
      localStorage.setItem("loggedIn", String(true));
      return updateObject(state, {
        userInfo: action.payload,
        user: action.payload.user_id,
        is_loaded: true,
        loading:false,
      });

    case actionTypes.AUTH_LOGIN_STATE_CHECKED:
      return updateObject(state, {
        session: action.payload,
        userInfo: action.payload,
        user: action.payload.user_id,
        is_loaded: true,
        loading:true,
      });

    case actionTypes.LOGOUT_USER_SUCCESS:
      return updateObject(state, {
        session: initialState.session,
        userInfo: null,
        user: null,
        is_loaded: true,
        loading:true,
        userLogout: true
      });

    case actionTypes.REGISTER_USER_SUCCESS:
      return updateObject(state, {
        userInfo: action.payload,
        user: action.payload.user_id,
        is_loaded: true,
        loading:true,
      });

    case actionTypes.REGISTER_USER_ERROR:
      return updateObject(state, {
        userInfo: action.payload,
        user: action.payload.user_id,
        is_loaded: true,
        loading:false,
      });

    case actionTypes.GET_USER_PROFILE:
      return updateObject(state, {
        userProfileData: action.payload,
        is_loaded: true,
        loading:false,
      });

    case actionTypes.FORGOT_PASSWORD_FAILED:
      return updateObject(state, {
        forgot_failed: action.payload
      });

    case actionTypes.CHANGE_PASS_PROFILE:
      return updateObject(state, {
        change_pass_loding: action.payload.is_success
      });

    case actionTypes.ACCOUNT_NOT_VERIFY_ERROR:
      return updateObject(state, {
        accountNotVeryfied: action.payload
      });

    case actionTypes.GET_USER_PREFRENCES:
      const preferences = action.payload;
      let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const tPreference = preferences.find((preference: any) => preference.preference_name === "TIMEZONE");
      if (tPreference && tPreference.preference_value) {
        timezone = tPreference.preference_information
      }
      return updateObject(state, {
        userPreferencesData: action.payload,
        timezone,
        is_loaded: true,
        loading: false,
      });

    case actionTypes.SCREEN_LOADING:
      return updateObject(state, {
        screen_loading: action.payload
      });

    case actionTypes.PASSWORD_CREATED:
      return updateObject(state, {
        passwordCreated: action.payload
      });
    case actionTypes.UPDATE_PRIVACY_SIGN:
      return updateObject(state, {
        privacyData: action.payload
      });

    case actionTypes.LOGIN_DETAILS:
      return updateObject(state, {
        loginDetails: action.payload
      });

    case actionTypes.CHANGE_PASSWORD_PROFILE:
      return updateObject(state, {
        changePasswordStatus: action.payload
      });

    case actionTypes.SET_USER_VERIFICATION:
      return updateObject(state, {
        isUserverification: action.payload
      });

    case actionTypes.GET_GOOGLE_ACCOUNT_PICTURE:
      return updateObject(state, {
        googleProfilePicture: action.payload
      });

    case actionTypes.GET_GAVATAR_IMAGE_SUCCESS:
      return updateObject(state, {
        gravatarImg: action.payload
      });

    default:
      return state;
  }
};

export default reducer;
